import { createFileRoute, Link } from '@tanstack/react-router';
import { useAuth } from '@/lib/auth/authContext';
import { useProperty } from '@/lib/property/propertyContextDef';
import { useBusinessListingsList } from '@/lib/data/listings';
import { formatNad } from '@/lib/money/format';
import { PageLoading } from '@/ui/Loader';

export const Route = createFileRoute('/listings/')({
  component: ListingsListPage,
});

function ListingsListPage() {
  const { supabase } = useAuth();
  const { businessId } = useProperty();
  const listingsQuery = useBusinessListingsList(supabase, businessId);

  return (
    <section className="flex flex-col gap-lg">
      <h1 className="text-screen-title font-extrabold tracking-tight text-ink">Listings</h1>

      {!businessId ? <p className="text-body text-ink-2">Select a property first.</p> : null}
      {listingsQuery.isLoading ? <PageLoading /> : null}
      {listingsQuery.isError ? <p className="text-body text-danger">Could not load your listings.</p> : null}

      {listingsQuery.data && listingsQuery.data.length > 0 ? (
        <div className="overflow-x-auto rounded-card border border-border bg-surface shadow-card">
          <table className="w-full min-w-[560px] text-body text-ink">
            <thead>
              <tr className="border-b border-hair text-left text-caption text-ink-2">
                <th className="px-md py-sm font-semibold">Title</th>
                <th className="px-md py-sm font-semibold">Type</th>
                <th className="px-md py-sm font-semibold">Price</th>
                <th className="px-md py-sm font-semibold">Status</th>
                <th className="px-md py-sm" />
              </tr>
            </thead>
            <tbody>
              {listingsQuery.data.map((l) => (
                <tr key={l.id} className="border-b border-hair last:border-0">
                  <td className="px-md py-sm font-semibold">{l.title}</td>
                  <td className="px-md py-sm text-ink-2">{l.listing_type}</td>
                  <td className="px-md py-sm text-ink-2">{l.price ? formatNad(l.price) : '—'}</td>
                  <td className="px-md py-sm">
                    <span
                      className={`rounded-chip px-sm py-[1px] text-caption font-semibold ${
                        l.is_active ? 'bg-tint-success text-success' : 'bg-tint-sand text-ink-2'
                      }`}
                    >
                      {l.is_active ? 'Published' : 'Draft'}
                    </span>
                  </td>
                  <td className="px-md py-sm text-right">
                    <Link
                      to="/listings/$id/edit"
                      params={{ id: l.id }}
                      className="text-caption font-semibold text-canyon underline"
                    >
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}

      {listingsQuery.data && listingsQuery.data.length === 0 ? (
        <p className="rounded-card border border-border bg-surface p-lg text-body text-ink-2">
          No listings yet. Add one from the mobile app to start editing it here.
        </p>
      ) : null}
    </section>
  );
}
